import React from 'react';
import { Link } from 'react-router-dom';
import { Icon } from '@iconify/react/dist/iconify.js';

/**
 * Raccourci métier compact sur la home.
 */
const PortalShortcutCard = ({ shortcut }) => (
  <Link to={shortcut.to} className="portal-shortcut-card">
    <div className="portal-shortcut-card__icon">
      <Icon icon={shortcut.icon} />
    </div>
    <div className="portal-shortcut-card__body">
      <h3 className="portal-shortcut-card__title mb-0">{shortcut.label}</h3>
      {shortcut.description ? (
        <p className="portal-shortcut-card__description mb-0">{shortcut.description}</p>
      ) : null}
    </div>
    <div className="portal-shortcut-card__action" aria-hidden>
      <Icon icon="solar:arrow-right-linear" />
    </div>
  </Link>
);

export default PortalShortcutCard;
